import { current } from '@reduxjs/toolkit';
import React, { createContext, useContext } from 'react';

export const ClaimContext = createContext({
  setCurrent: 0,
  setClaimForm: {},
  claimForm: {},
  supportOptions: [],
  setSupportOptions: [],
  setIsBlocking: true,
  pdfFormData: {},
  setPdfFormData: {},
  supportingCurrent: '',
  setSupportingCurrent: '',
  patientCurrent: 0,
  setPatientCurrent: 0,
  linkedAccount: [],
  setLinkedAccount: [],
  achTnc: false,
  setAchTnc: false,
});

export const useClaimContext = () => useContext(ClaimContext);
